export default {
  getQuartersWithPeriod: state => {
    const { periods } = state
    const data = []
    periods.forEach(period => {
      const { quarters } = period
      quarters.forEach(quarter => {
        data.push({
          id: quarter.id,
          name: `${period.admission_year}/${quarter.quarter}`,
        })
      })
    })
    return data
  },
  getPeriod: state => id => state.periods.find(period => period.id === id),
}
